import React, { useState, useEffect } from 'react';
import './CrashScreen.css';

const CrashScreen = ({ onReboot }) => {
  const [showReboot, setShowReboot] = useState(false);

  useEffect(() => {
    // Show reboot button after 2 seconds
    const timer = setTimeout(() => {
      setShowReboot(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="crash-screen">
      <div className="crash-content">
        <div className="crash-icon">💀</div>
        <h1 className="crash-title">CRITICAL SYSTEM ERROR</h1>
        <div className="crash-code">
          <p>*** STOP: 0x0000007B (0xF78D2524, 0xC0000034, 0x00000000, 0x00000000)</p>
          <p>INACCESSIBLE_BOOT_DEVICE</p>
        </div>
        <div className="crash-message">
          <p>A critical file has been permanently deleted from the system.</p>
          <p>The system has been halted to prevent further damage.</p>
        </div>
        {showReboot && (
          <button className="reboot-button" onClick={onReboot}>
            REBOOT SYSTEM
          </button>
        )}
        {!showReboot && (
          <div className="crash-spinner">
            <div className="spinner"></div>
            <p>System halted...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CrashScreen;
